import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import PageHeader from "../components/ui-custom/PageHeader";
import { useData } from "../hooks/useData";
import { Reveal } from "../components/ui-custom/Reveal";
import { ArrowUpRight, Clock } from "lucide-react";

export default function Blog() {
  const { data } = useData("blog");
  return (
    <>
      <Seo title="Blog" description="Insights, guides and updates from utipanagecy on digital services, PAN, banking and fintech growth." />
      <PageHeader eyebrow="Blog" title={data?.heading || "Insights from the utipanagecy blog"} sub="Guides and stories to help you grow your digital business." />
      <Section testId="blog-page">
        <div className="grid gap-6 md:grid-cols-2">
          {data?.posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.08}>
              <article className="group h-full overflow-hidden rounded-3xl glass transition-all duration-300 hover:-translate-y-1" data-testid={`blog-post-${p.id}`}>
                <div className="relative h-52 overflow-hidden">
                  <img src={p.image} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <span className="absolute left-4 top-4 rounded-full glass-strong px-3 py-1 text-xs font-medium text-brand-2">{p.category}</span>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-xs text-slate-400">
                    <span>{new Date(p.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
                    <span className="flex items-center gap-1"><Clock size={12} /> {p.readTime}</span>
                  </div>
                  <h3 className="mt-3 text-xl font-semibold text-slate-900 transition-colors group-hover:text-brand">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-500">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-brand">Read more <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
}
